import React, { useEffect } from 'react';
import './Notification.css';

const Notification = ({ message, show, type = 'success', onClose, duration }) => {
  // Función para obtener duración según tipo de notificación
  const getNotificationDuration = (notificationType) => {
    switch (notificationType) {
      case 'error':
        return 6000;    // Errores: 6 segundos (más tiempo para leer)
      case 'warning':
        return 5000;    // Advertencias: 5 segundos
      case 'info':
        return 4000;    // Información: 4 segundos
      case 'success':
        return 2500;    // Éxitos: 2.5 segundos (más rápido)
      default:
        return 3000;    // Default: 3 segundos
    }
  };

  // Usar duración personalizada o calcular según tipo
  const finalDuration = duration || getNotificationDuration(type);

  // Manejar auto-ocultado
  useEffect(() => {
    if (show && onClose) {
      const timer = setTimeout(() => {
        onClose();
      }, finalDuration);

      return () => clearTimeout(timer);
    }
  }, [show, onClose, finalDuration]);

  // Función para cerrar manualmente al hacer clic
  const handleClick = () => {
    if (onClose) {
      onClose();
    }
  };

  // Solo renderiza si show es true Y hay mensaje
  if (!show || !message) return null;

  const getIcon = () => {
    switch (type) {
      case 'success':
        return '✅';
      case 'error':
        return '❌';
      case 'warning':
        return '⚠️';
      case 'info':
        return 'ℹ️';
      default:
        return '✅';
    }
  };

  return (
    <div
      className={`notification notification--${type} show`}
      role="alert"
      onClick={handleClick}
      title="Haz clic para cerrar"
    >
      <div className="notification__icon">{getIcon()}</div>
      <div className="notification__content">
        <div className="notification__message">{message}</div>

      </div>
    </div>
  );
};

export default Notification;